import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import AboutHero from "@/pages/about/components/AboutHero";
import AboutIntroSection from "@/pages/about/components/AboutIntroSection";
import AboutCardsSection from "@/pages/about/components/AboutCardsSection";
import AboutOutroSection from "@/pages/about/components/AboutOutroSection";
import { Link } from "react-router-dom";

export default function AboutEnPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="About us | NetBasis International"
        description="Learn more about NetBasis International – your industry expert for strategic and operational commercial support since 2008."
        ogUrl="https://net-basis.net/en/about-us"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <AboutHero
          texts={{
            title_line1: "We make things ",
            title_line2: "happen ...",
            subtitle: "... for YOU!",
          }}
        />

        <AboutIntroSection
          texts={{
            h1: "Your experienced partner for sustainable market success in the DACH region. Under the guiding theme \"linking people & business,\" we support foreign ICT manufacturers from strategic planning to successful on-site operational execution.",
            p1: "NetBasis International was founded in Düsseldorf at the beginning of 2008. Since then, under the motto \"linking people & business,\" we have been offering foreign manufacturers from the telecommunications and IT industry, who wish to expand their business activities into the DACH markets or intensify existing activities, all forms of consulting and commercial support as well as expert assistance in market-specific product development and adaptation.",
            p2: "Together with our manufacturer partners, we answer all strategic questions and work focused on one single concern: your success and the best business results in new markets!",
            p3: "To achieve this goal, foreign companies gain immediate access through us to industry-specific knowledge, long-standing market experience, and extensive contacts. They avoid cultural or linguistic barriers through our immediate presence and benefit from our prompt operational work across markets, products, partners, and customers.",
            strongName: "NetBasis International",
          }}
        />

        <AboutCardsSection
          texts={{
            management_title: "Management",
            management_desc: "Over 30 years of industry expertise: Benefit from deep market insight and long-standing international leadership experience for your success in the DACH region.",
            core_values_title: "Core Values",
            core_values_desc: "Values you can build on: Driven by respect, loyalty and professionalism, we ensure your DACH region success – your project is in the safest hands.",
            mission_vision_title: "Mission/Vision",
            mission_vision_desc: "People make the difference: Technology alone does not guarantee success. Through close collaboration, we lead your market project to a secure outcome.",
            read_more: "Learn more",
          }}
          urls={{
            management: "/en/about-us/management",
            core_values: "/en/about-us/core-values",
            mission_vision: "/en/about-us/mission-vision",
          }}
        />

        <AboutOutroSection
          texts={{
            strongName: "NetBasis International",
            p4: "To strengthen existing relationships as well as win new customers and thus ensure a more sustainable development of new markets, we rely on a partnership-based approach in all areas of sales and marketing. This includes working together on sophisticated hardware and software solutions perfectly adapted to current market requirements.",
            p5: "Both our corporate philosophy and our ethical alignment dictate that NetBasis International strategically concentrates on a limited number of competent manufacturer partners who do not stand in direct competition within the industry. We deliberately favor joint development and synergetic cooperation within the group over unproductive competition.",
            p6: "All this offers maximum security for every new partner and is an integral part of the package we offer you when you decide on a successful cooperation with us.",
          }}
        />

        {/* Contact CTA */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              Get in touch with us directly now.
            </h2>
            <Link
              to="/en/contact"
              className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-4 font-heading text-sm md:text-base font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Form
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}